module.exports = __webpack_public_path__ + "img/logo.e806de1c.png";